const Pattern = (props) => {
  const { modifier } = props;

  const patternStyle = modifier ? `Pattern ${modifier}` : 'Pattern';

  return <div className={patternStyle} />;
};

export default Pattern;
